import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-list-container',
  templateUrl: './skeleton-list-container.component.html',
  styleUrls: ['./skeleton-list-container.component.sass'],
})
export class SkeletonListContainerComponent {
  
  @Input() isLoading = false;  
  @Input() error = false;  
  @Input() empty = false;  
  

  constructor() {}
}
